export default "__VITE_ASSET__CS_GCkmD__"